import { portalPaths } from '@provision/portal-routes';
import { UserGroupRules } from 'src/graphql';
import { type NavigationDestination } from 'src/utils/navigation/navigation.types';

export const REPORTS_NAVIGATION: NavigationDestination[] = [
  {
    id: 'subscriptions',
    title: 'Subscriptions',
    iconData: { name: 'receipt', library: 'lucide' },
    path: portalPaths.settings.stripeReport(),
    allowedRules: [UserGroupRules.Reports],
    isMultitenancyAllowed: false,
    isMobileSupported: false,
  },
];
